<template>
  <template v-if="service.children.length > 0">
    <ServiceItem
      v-for="item in service.children"
      :service="item"
      :isSettingMode="isSettingMode"
      :key="item.productTypeCode"
    />
  </template>
  <div v-else class="product-item">
    <div class="wrap">
      <c-label :ellipsis="true" class="product-text product-name">{{
        service.productTypeName
      }}</c-label>
      <c-label :ellipsis="true" class="product-text product-desc">{{
        service.productTypeDescription
      }}</c-label>
    </div>
    <div
      @click="goUrl(service.urlCode)"
      :class="isSettingMode && 'cursor'"
      class="product-text product-count"
    >
      {{ service.count }}
    </div>
  </div>
</template>

<script>
import { MONITORING_WIDGET_URL } from '@/containers/utils/constant';
import ServiceItem from '@/containers/widget/components/MonitoringStatusWidget/ServiceItem.vue';

export default {
  components: { ServiceItem },
  props: {
    service: {
      type: Object,
      default: () => ({})
    },
    isSettingMode: { type: Boolean, default: false }
  },
  methods: {
    goUrl(productTypeCode) {
      if (this.isSettingMode) return;

      if (productTypeCode) {
        this.$store.commit('setParameters', {
          performanceList: { productTypeCode }
        });
      }

      this.$router.push({ name: MONITORING_WIDGET_URL });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px 12px 16px;

  &:first-child {
    padding-top: 0;
  }

  .product-text {
    font-family: $lego__font-family;
    font-size: 13px !important;
    font-style: normal !important;
    color: var(--dark) !important;
    line-height: 16px !important;
    padding: 0 0 1px 0;
  }

  .wrap {
    width: 90%;
    text-align: left;

    .product-name {
      font-weight: 400;
    }

    .product-desc {
      font-size: 11px !important;
    }
  }

  .product-count {
    font-weight: 700;
    cursor: pointer;
  }

  .cursor {
    cursor: unset !important;
  }
}
</style>
